import { render, staticRenderFns } from "./digital_module.vue?vue&type=template&id=4b3a6c05&scoped=true"
import script from "./digital_module.vue?vue&type=script&lang=js"
export * from "./digital_module.vue?vue&type=script&lang=js"
import style0 from "./digital_module.vue?vue&type=style&index=0&id=4b3a6c05&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a6c05",
  null
  
)

export default component.exports